
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexRb3glB6PtG5CCQ8MgedcNe5DkLOfP_lo3i0DwA6SFToMeta } from "/src/client/layers/base/pages/index.vue?macro=true";
import { default as indexIyeZn3kZEyHq50P5ZbjE3vzztPCUa_NMZmRVMILh_xoMeta } from "/src/client/layers/base/pages/info/index.vue?macro=true";
import { default as index7q7QpkK6IrpU6NdHXSACC9zwaefgOzcqIBNPKZLsVt8Meta } from "/src/client/layers/base/pages/search/index.vue?macro=true";
import { default as indexvZiXhNa11ivjVSeZXEfYevH8CH0litxrZtRnucpAFJgMeta } from "/src/client/layers/base/pages/products/index.vue?macro=true";
import { default as indextPixX95OZrvtKwASb48NVIe_WNPliXtsd4_nq_DECNMMeta } from "/src/client/layers/base/pages/downloads/index.vue?macro=true";
import { default as indexsTH_PXSJ_GBpqoPh_6QOshOyNZ44xd1KIrNz2mWAiNEMeta } from "/src/client/layers/base/pages/info/[category]/index.vue?macro=true";
import { default as indexXWTtizUjfqBrxphwQ1U6rKI8tQrnvFz9YQlga5pDUfYMeta } from "/src/client/layers/base/pages/products/[category]/index.vue?macro=true";
import { default as indexBGG_cN3fdo409dK9i5DGhS6Q6r_DNwR5V0sdUidev8QMeta } from "/src/client/layers/base/pages/downloads/[category]/index.vue?macro=true";
import { default as indexLzJJvL0rqlCi8kYsfYrpfvnO0t5IanvsVuiNnlMI4oIMeta } from "/src/client/layers/base/pages/products/[category]/[subcategory]/index.vue?macro=true";
import { default as indexVNSRnUXHQ_OfP9apfJVtkYxiHbDSNeX4FTL60f6_FA4Meta } from "/src/client/layers/base/pages/products/[category]/[subcategory]/[subcategoryTab]/index.vue?macro=true";
import { default as indexNma2NCWBYImFROtADsfAEQCqspLOw2Hde3UE8jZiTYQMeta } from "/src/client/layers/base/pages/products/[category]/[subcategory]/[subcategoryTab]/[product]/index.vue?macro=true";
import { default as _91subcategory_939XsrpheAHeZMGgpCjl7hsX1dU3XbfdFXeKHSiWvEvhcMeta } from "/src/client/layers/base/pages/products/[category]/[subcategory].vue?macro=true";
import { default as indexK_hy7otuMR4FdVo8sLzVlEPd3qZXBz52pL_KKe9W4ugMeta } from "/src/client/layers/base/pages/downloads/[category]/[subcategory]/index.vue?macro=true";
import { default as index_ScgW1_7jFzRtiBGL_ky3yejfUL0lU7_aXllUunLFfQMeta } from "/src/client/layers/base/pages/downloads/[category]/[subcategory]/[subcategoryTab]/index.vue?macro=true";
import { default as index5qQzYYMQe5Q1EyGH5fj6PiBWnnaJP5DCCTcIpRWGgQEMeta } from "/src/client/layers/base/pages/downloads/[category]/[subcategory]/[subcategoryTab]/[product]/index.vue?macro=true";
import { default as _91subcategory_93P3ud7KmUoYmEDnNQqMOeGI86OkG1D0t7A2_Mm9z_MmoMeta } from "/src/client/layers/base/pages/downloads/[category]/[subcategory].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/index.vue")
  },
  {
    name: "info",
    path: "/info",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/info/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/src/client/layers/base/pages/search/index.vue")
  },
  {
    name: "products",
    path: "/products",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/products/index.vue")
  },
  {
    name: "downloads",
    path: "/downloads",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/downloads/index.vue")
  },
  {
    name: "info-category",
    path: "/info/:category()",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/info/[category]/index.vue")
  },
  {
    name: "products-category",
    path: "/products/:category()",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/products/[category]/index.vue")
  },
  {
    name: "downloads-category",
    path: "/downloads/:category()",
    meta: {"middleware":"check-token"},
    component: () => import("/src/client/layers/base/pages/downloads/[category]/index.vue")
  },
  {
    name: _91subcategory_939XsrpheAHeZMGgpCjl7hsX1dU3XbfdFXeKHSiWvEvhcMeta?.name,
    path: "/products/:category()/:subcategory()",
    meta: {"middleware":["check-products-url"]},
    component: () => import("/src/client/layers/base/pages/products/[category]/[subcategory].vue"),
    children: [
  {
    name: "products-category-subcategory",
    path: "",
    meta: { ...(indexLzJJvL0rqlCi8kYsfYrpfvnO0t5IanvsVuiNnlMI4oIMeta || {}), ...{"middleware":["redirect-to-tab","check-token"]} },
    component: () => import("/src/client/layers/base/pages/products/[category]/[subcategory]/index.vue")
  },
  {
    name: "products-category-subcategory-subcategoryTab",
    path: ":subcategoryTab()",
    meta: {"middleware":["check-channel-nodes","check-token"]},
    component: () => import("/src/client/layers/base/pages/products/[category]/[subcategory]/[subcategoryTab]/index.vue")
  },
  {
    name: "products-category-subcategory-subcategoryTab-product",
    path: ":subcategoryTab()/:product()",
    meta: {"middleware":["check-channel-nodes","check-token"]},
    component: () => import("/src/client/layers/base/pages/products/[category]/[subcategory]/[subcategoryTab]/[product]/index.vue")
  }
]
  },
  {
    name: _91subcategory_93P3ud7KmUoYmEDnNQqMOeGI86OkG1D0t7A2_Mm9z_MmoMeta?.name,
    path: "/downloads/:category()/:subcategory()",
    meta: {"middleware":["check-downloads-url"]},
    component: () => import("/src/client/layers/base/pages/downloads/[category]/[subcategory].vue"),
    children: [
  {
    name: "downloads-category-subcategory",
    path: "",
    meta: {"middleware":["check-token"]},
    component: () => import("/src/client/layers/base/pages/downloads/[category]/[subcategory]/index.vue")
  },
  {
    name: "downloads-category-subcategory-subcategoryTab",
    path: ":subcategoryTab()",
    meta: {"middleware":["check-channel-nodes","check-token"]},
    component: () => import("/src/client/layers/base/pages/downloads/[category]/[subcategory]/[subcategoryTab]/index.vue")
  },
  {
    name: "downloads-category-subcategory-subcategoryTab-product",
    path: ":subcategoryTab()/:product()",
    meta: {"middleware":["check-channel-nodes","check-token"]},
    component: () => import("/src/client/layers/base/pages/downloads/[category]/[subcategory]/[subcategoryTab]/[product]/index.vue")
  }
]
  }
]